<template>
  <div 
        :class="{
            'component z-input-image can-loading': true, 
            'loading': loading,
            'disabled': $props.disabled, 
            'readonly': $props.readonly
        }"
        v-bind:style="'width: calc(' + $props.width + ')'"
    >
    <label :for="inputId">
        <span v-show="showLabel">{{$props.label + ($props.readonly ? ' (Только для чтения)' : '')}}</span>
        
        <md-button  class="md-primary md-dense"  v-on:click="openFileDialog" v-bind:width="$props.width">{{$props.buttonText}}</md-button>

        <span class="error" v-if="uploadError">{{uploadError}}</span>
        <input
            ref="input"
            v-bind:id="inputId"
            type="file"
            :name="$props.name"
            :disabled="$props.disabled"
            :readonly="$props.readonly"
            :placeholder="$props.placeholder"
            :min="$props.min"
            :max="$props.max"
            @focus="onFocus"
            @blur="onBlur"
            v-on:change="changeFiles"
            accept=".jpg,.jpeg,.png,.gif"
        >
    </label>

    <div class="z-input-image__container">
        <div class="z-input-image__preview-images">
            <div class="z-input-image__preview-image" v-for="(img, i) in previewImages" v-bind:key="i">
                <img v-bind:src="img.src" v-bind:alt="'image-' + i">
                <div class="z-input-image__preview-image__percent" v-show="img.inprogress">{{img.percent + '%'}}</div>
                <div class="z-input-image__preview-image__upload" v-show="img.upload"><i class="fas fa-check"></i></div>
                <div class="z-input-image__preview-image__error" v-show="img.error"><i class="fas fa-exclamation"></i></div>
            </div>
        </div>
    </div>

    <span class="error" v-show="$props.error">{{$props.error}}</span>
  </div>
</template>
<script>
    export default {
        name: 'z-input-image',
        props: {
            showLabel:    {type: Boolean, default: true},
            placeholder:  {type: String, default: ''},
            imgHeightMin: {type: Number, default: null},
            imgWidthMin:  {type: Number, default: null},
            imgHeightMax: {type: Number, default: null},
            imgWidthMax:  {type: Number, default: null},
            disabled: {type: Boolean, default: false},
            readonly: {type: Boolean, default: false},
            label: {type: String, default: ''},
            link:  {type: String, default: ''},
            value: {type: [String, Number, Date, 'time'], default: () => ''},
            width: {type: String, default: '100% - 20px'},
            name:  {type: String, default: ''},
            error: {type: String, default: ''},
            min:   {type: [String, Number, Date], default: () => null},
            max:   {type: [String, Number, Date], default: () => null},
            buttonText: {type: String, default: 'Загрузить'},
        },
        data() {
            return {
                inputValue: '',
                previewImages: {},
                loading: false,
                uploadError: '',
                imagesCount: 0
            }
        },
        created() {
            this.$nextTick(() => {
                this.inputValue = this.$props.value;
            });
        },
        watch: {
            '$props.value'(newVal) {
                this.inputValue = newVal;
            },
            'inputValue'(newVal) {
                this.$emit('input', newVal);
                this.$emit('change', newVal);
            }
        },
        computed: {
            inputId() {
                return 'input-' + this._uid;
            }
        },
        methods: {
            onFocus() {
                this.$emit('focus');
            },
            onBlur() {
                this.$emit('blur');
            },
            openFileDialog() {
                if (!this.$refs.input) alert('Не удалось найти форму загрузки файла. Обновите страницу.');
                this.$refs.input.click();
            },
            checkComplete() {
                let completeImages = 0;
                Object.keys(this.previewImages).map(i => {
                    if (this.previewImages[i]['upload']) completeImages++;
                });
                if (completeImages == this.imagesCount) {
                    this.$emit('complete');
                    setTimeout(() => this.clearImages(), 2000);
                }
            },
            clearImages() {
                this.previewImages = {};
                this.uploadError = '';
                this.imagesCount = 0;
            },
            changeFiles(e) {
                if(!window.File || !window.FileList || !window.FileReader) {
                    alert('Ваш браузер не поддерживает File API. Пожалуйста, используйте другой браузер.');
                    return;
                }
                if (!e || !e.target || !e.target.files) return;
                
                let files = e.target.files;
                this.previewImages = {};
                this.imagesCount = files.length;
                
                for(let i = 0; i < files.length; i++) {
                    let image = files[i];
                    if (!image.type.match('image')) continue;
                    
                    let picReader = new FileReader();
                    picReader.addEventListener('load', (event) => {
                        let picFile = event.target, img = new Image();
                        img.src = picFile.result;
                        img.onload = (e) => {
                            let target = e.path.find(item => !!item);
                            this.previewImages[i] = {
                                i:          i,
                                image:      image,
                                src:        picFile.result,
                                size:       image.size,
                                width:      target.width,
                                height:     target.height,
                                percent:    0,
                                upload:     false,
                                inprogress: false,
                                error:      false
                            };
                            this.$forceUpdate();
                            if (Object.values(this.previewImages).length === files.length) this.uploadImages(this.previewImages);
                        }
                    });
                    picReader.readAsDataURL(image);
                }
            },
            uploadImages(images) {
                let error = [];
                Object.values(images).map(image => {
                    if (image && image.size > (5 * 1024 * 1024)) {
                        error.push('Изображение слишком большое. Максимальный размер изображения 5 МБ.');
                        image.error = true;
                    }
                    
                    if (this.$props.imgHeightMin && this.$props.imgWidthMin)
                        if (image.height < this.$props.imgHeightMin || image.width < this.$props.imgWidthMin) {
                            error.push('Минимальный размер изображения ' + this.$props.imgWidthMin + 'x' + this.$props.imgHeightMin + 'px');
                            image.error = true;
                        }

                    if (this.$props.imgHeightMax && this.$props.imgWidthMax)
                        if (image.height > this.$props.imgHeightMax || image.width > this.$props.imgWidthMax) {
                            error.push('Максимальный размер изображения ' + this.$props.imgWidthMax + 'x' + this.$props.imgHeightMax + 'px');
                            image.error = true;
                        }
                });

                if (error.length) this.uploadError = error.join(' ');
                else Object.values(images).map(item => this.uploadImage(item.image, item.i));
            },
            uploadImage(image, i) {
                const config = {
                    headers: { 'Content-Type': 'multipart/form-data' },
                    onUploadProgress: (progressEvent) => {
                        let percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        this.previewImages[i]['percent'] = percent;
                        if (percent >= 100) this.previewImages[i]['inprogress'] = false;
                        this.$forceUpdate();
                        this.checkComplete();
                    }
                };
                this.previewImages[i]['inprogress'] = true;
                this.$forceUpdate();

                let data = new FormData();
                data.append('file', image);

                this.uploadError   = '';
                this.loading = true;
                return this.$http.post(this.$props.link, data, config).then(r => {
                    this.previewImages[i]['upload'] = true;
                    this.$forceUpdate();
                    this.checkComplete();
                }).catch(e => {
                    if (e && e.response && e.response.data && e.response.data.error) this.uploadError = e.response.data.error;
                    else this.uploadError = this.$root.unknownError;
                    
                    this.previewImages[i]['error'] = true;
                    this.$forceUpdate();
                    this.checkComplete();

                }).finally(r => this.loading = false);
            }
        }
    }
</script>
<style lang="css">
    .z-input-image{
        display: flex;
        flex-direction: column;
        margin: 0 10px 10px 10px;
    }
    .z-input-image input{
        display: none;
        border: 1px solid #c1c1c1ee;
        border-radius: 2px;
        height: 30px;
        padding: 0 5px;
        font-size: 14px;
        line-height: 15px;
        background-color: #fff;
    }
    .z-input-image label span{
        display: block;
        font-size: 14px;
        line-height: 14px;
        margin-bottom: 2px;
    }
    .z-input-image .error{
        font-size: 13px;
        line-height: 13px;
        display: block;
        padding-top: 4px;
        color: red;
    }

    .z-input-image.disabled,
    .z-input-image.readonly{
        cursor: not-allowed;
        opacity: 0.8;
    }
    .z-input-image.disabled label,
    .z-input-image.readonly label{
        cursor: not-allowed;
    }
    .z-input-image.disabled input,
    .z-input-image.readonly input{
        cursor: not-allowed;
        background: #eaeaea;
    }

    .z-input-image .btn{
        margin: 0;
    }

    .z-input-image__container{
        width: 100%;
        padding: 5px 0 0 0;
    }
    .z-input-image__preview-images{
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: flex-start;
        margin: -2px;
    }
    .z-input-image__preview-image{
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100px;
        width: 100%;
        max-width: 100px;
        max-height: 100px;
        overflow: hidden;
        border: 2px solid #2196f3;
        padding: 1px;
        border-radius: 4px;
        margin: 2px;
        position: relative;
    }
    .z-input-image__preview-image img{
        display: block;
        max-width: 100%;
        max-height: 100%;
        position: relative;
        z-index: 1;
    }
    .z-input-image__preview-image__percent,
    .z-input-image__preview-image__upload,
    .z-input-image__preview-image__error{
        position: absolute;
        z-index: 2;
        width: 100%;
        height: 100%;
        background: rgba(33, 150, 243, 0.6);
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 20px;
        line-height: 20px;
    }
    .z-input-image__preview-image__error{
        background: rgba(255, 100, 100, 0.6);
        z-index: 3;
    }
    .z-input-image__preview-image__upload{
        font-size: 26px;
        line-height: 26px;
    }
</style>


// WEBPACK FOOTER //
// ZInputImage.vue?45e1fee5